import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../common/Table';
import CollapsibleHeader from '../../../../layout/CollapsibleHeader';
import { SALES_SESSION_DEBIT_NOTES_COLUMNS } from '../../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';

const LiquidationDebitNotesTable = ({ debitNoteList }) => (
  <>
    <Table
      columns={SALES_SESSION_DEBIT_NOTES_COLUMNS}
      data={debitNoteList}
      showPagination
      manual={false}
      filterable
      defaultFilterMethod={filterMethodCaseInsensitive}
    />
    <br />
  </>
);

LiquidationDebitNotesTable.propTypes = {
  debitNoteList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      voucherType: PropTypes.string,
      contingency: PropTypes.bool,
    }),
  ).isRequired,
};

const LiquidationDebitNoteResource = ({ debitNoteList }) => {
  if (!debitNoteList || !debitNoteList.length) {
    return null;
  }

  return (
    <>
      <hr />
      <CollapsibleHeader
        headerText="Notas de Débito"
        component={LiquidationDebitNotesTable}
        debitNoteList={debitNoteList}
      />
    </>
  );
};

LiquidationDebitNoteResource.propTypes = {
  debitNoteList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      voucherType: PropTypes.string,
      contingency: PropTypes.bool,
    }),
  ),
};

LiquidationDebitNoteResource.defaultProps = {
  debitNoteList: [],
};

export default LiquidationDebitNoteResource;
